import {
    put, takeLatest, all, PutEffect,
} from "redux-saga/effects";
import axios, {AxiosResponse} from "axios";
import {Nullable, safeSaga} from "@data-force/app";
import {GET_DATEPICKER_TRANSLATION, setDatepickerTranslation} from "../actions/antdTranslation";
import {
    GetDatepickerTranslationAction,
    SetDatepickerTranslationAction,
} from "../../interfaces/store/actions/antdTranslation";
import {TranslationJson} from "../../interfaces/translationJson";

type GetDatepickerTranslationIteratorType =
    | Promise<AxiosResponse<GetDatepickerTranslationAction>>
    | PutEffect<SetDatepickerTranslationAction>;

function* getDatepickerTranslation({payload}: GetDatepickerTranslationAction): IterableIterator<GetDatepickerTranslationIteratorType> {
    const axiosResponse: Nullable<{ data: TranslationJson }> = yield axios.get(`/i18n/antd/${payload}.json`);
    if (axiosResponse) {
        const {data}: { data: TranslationJson } = axiosResponse;
        yield put(setDatepickerTranslation(data.DatePicker));
    }
}

export function* actionWatcher() {
    yield all([
        takeLatest(GET_DATEPICKER_TRANSLATION, safeSaga(getDatepickerTranslation)),
    ]);
}
